import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-expansion-container',
  templateUrl: './expansion-container.component.html',
  styleUrls: ['./expansion-container.component.scss'],
})
export class ExpansionContainerComponent {
  @Input() panelHeader!: string;
  @Input() panelTitle!: string;
  @Input() panelOpen!: boolean;
  @Input() simple!: boolean;
  @Output() opened = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  constructor() {}

  emitOpened(): void {
    this.opened.emit();
  }

  emitClosed(): void {
    this.closed.emit();
  }
}
